import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DraggableItem } from './draggable-item';

interface Props {
    disabled: boolean;
    id: string;
    active: boolean;
    node: JSX.Element;
}
export function SortableItem(props: Props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: props.id, disabled: props.disabled });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <DraggableItem ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {props.node}
        </DraggableItem>
    );
}